import React, { useEffect, useState } from 'react';
import './SearchResults.scss';
import { InteractiveDiv, Typography } from '@pinwheel/origami';
import CompanyIcon from '../../components/CompanyIcon';
import { useOpts } from '../../context';
// --------------- SearchResult (single) ---------------
export var BG_COLORS = [
    '#4DB36A',
    '#EBAE11',
    '#EB7911',
    '#E07272',
    '#589BFF',
    '#8358FF',
];
var SearchResult = function (_a) {
    var result = _a.result, loading = _a.loading, onResultClick = _a.onResultClick, i = _a.i, backgroundColor = _a.backgroundColor;
    // Apply an accessible name to the button container. Since the label (platform name)
    // is already present on the DOM, use `aria-labelledby` instead of `aria-label`.
    var labelId = "searchResults-platform-".concat(result.id);
    return (React.createElement(InteractiveDiv, { "data-testid": "searchResults-".concat(i).concat(loading ? '-loading' : ''), "aria-busy": loading, key: "searchResults-".concat(i), onClick: function () { return loading || onResultClick(result); }, "aria-labelledby": labelId, sx: {
            cursor: loading ? 'auto' : 'pointer',
            fontWeight: '500',
            position: 'relative',
            padding: '12px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-word',
            '&:hover': {
                backgroundColor: {
                    type: 'theme',
                    colorLegacy: 'Neutral/10',
                    colorNext: 'neutral/default',
                    opacityNext: 0.12,
                },
            },
            '&:active': {
                backgroundColor: {
                    type: 'theme',
                    colorLegacy: 'Neutral/20',
                    colorNext: 'neutral/default',
                    opacityNext: 0.24,
                },
            },
        } },
        React.createElement(CompanyIcon, { result: result, loading: loading, backgroundColor: backgroundColor, dataTestId: "searchResult" }),
        loading ? (React.createElement("div", { "data-testid": "loadingBar", role: "progressbar", "aria-label": "Loading", className: "searchResults__loadBar" })) : (React.createElement(Typography, { variant: "body", id: labelId, sx: { marginLeft: '12px' } }, result.name))));
};
export var SearchResults = function (props) {
    var setCompanyColor = useOpts().setCompanyColor;
    var results = props.results, onResultClick = props.onResultClick, lastItem = props.lastItem, loading = props.loading;
    var searchResults = loading
        ? Array.from({ length: 9 }, function () { return ({ name: '' }); }) // 9 blank results for loading animation
        : results;
    var _a = useState(null), scrollingElement = _a[0], setScrollingElement = _a[1];
    useEffect(function () {
        if (results.length && scrollingElement)
            scrollingElement.scrollTop = 0;
    }, [results, scrollingElement]);
    var missingLogoCount = 0;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: setScrollingElement, className: "searchResults ".concat(loading ? 'searchResults--loading' : ''), "aria-busy": loading, "data-testid": "searchResults-list", style: {
                marginBottom: '32px',
            } },
            searchResults.length ? (searchResults.map(function (result, i) {
                var backgroundColor = result.logoUrl
                    ? null
                    : BG_COLORS[missingLogoCount++ % BG_COLORS.length];
                return (React.createElement(SearchResult, { key: i, i: i, onResultClick: function (x) {
                        setCompanyColor(backgroundColor);
                        onResultClick(x);
                    }, result: result, loading: loading, backgroundColor: backgroundColor }));
            })) : (React.createElement("div", { "data-testid": "searchResults-empty" })),
            lastItem || null)));
};
